import { Box, styled } from "@mui/material";

export const SideNavigationMenuWrapper = styled(Box)<{ open: boolean }>(({ open }) => {
    return {
        display: open ? "block" : "none",
        "& ul": {
            marginBlockEnd: 0,
            marginInline: 0,
            paddingInline: "56px 0",
            display: "flex",
            flexDirection: "column",
            gap: "calc(var(--flex-gap)/4)",
        },
        "& li": {
            fontFamily: "Poppins",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "normal",
            color: "var(--light-color)",
            textWrap: "wrap",
            display: "block",
            minHeight: "unset",
            borderRadius: "16px",
            padding: "calc(var(--basic-padding)/4) calc(var(--basic-padding)/2)",
        },
        "& li:hover": {
            backgroundColor: "var(--active-primary-button)",
        },
    }
})